export default __webpack_public_path__ + "static/survivor-96c77365904e2ec7c858d9b33e6a397b.png";